import React from 'react';
import { Row } from 'antd';
import UsersRegisterTable from './table';
import './index.less';

const UserManager = () => {
  return (
    <div className='page-top-div'>
      {/* <span className='text-span'>Users Manager</span> */}
      <Row className=''>
        <UsersRegisterTable />
      </Row>
    </div>
  );
};

export default UserManager;
